import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      isDark: false,
      url: '',
    }
  },
  computed: {
    ...mapGetters({
      loading: 'getLoading',
    }),
  },
  mounted() {
    this.url = this.addTimer(
      'https://oss.mrepress.net/static/console/data_center.html'
    )
  },
  methods: {
    changeDark() {
      this.isDark = true
      this.url = this.addTimer(
        'https://oss.mrepress.net/static/console/data_center_dark.html'
      )
    },
    changeLight() {
      this.isDark = false
      this.url = this.addTimer(
        'https://oss.mrepress.net/static/console/data_center.html'
      )
    },
    addTimer(url) {
      const time = moment().valueOf()
      return url + '?_' + time
    },
  },
}
